import _, { result } from "lodash";

import * as addGuestProfile from '@/api/crm/guestProfiles/addGuestProfile';
import * as updateGuestProfile from '@/api/crm/guestProfiles/updateGuestProfile';
import * as deleteGuestProfile from '@/api/crm/guestProfiles/deleteGuestProfile';
import * as queryGuests from '@/api/crm/guestProfiles/queryGuests.js';
import * as getGuestProfile from '@/api/crm/guestProfiles/getGuestProfile.js';
import * as getGuestValue from '@/api/crm/guestProfiles/getGuestValue.js';
import * as getGuestStatistics from '@/api/crm/guestProfiles/getGuestStatistics.js';
import * as addVenueConsent from '@/api/crm/guestProfiles/addVenueConsent';
import * as removeVenueConsent from '@/api/crm/guestProfiles/removeVenueConsent';
import * as addGuestProfileNote from '@/api/crm/guestProfiles/addGuestProfileNote';
import * as getCountByGuestQuery from '@/api/crm/guestProfiles/getCountByGuestQuery';


export default {
    namespaced: true,
    state: {
        consentNames: ["Personal Data", "Analytics", "Enrichment", "Email", "Phone", "SoMe", "Snail Mail", "Marketing"],
        consentTypes: ["PersonalData", "Analytics", "Enrichment", "Email", "Phone", "SoMe", "SnailMail", "Marketing"],
        profiles: {},
        guestStatistics: null,
        values: {},
        queryResult: [],
        searching: false,

        guestQuerySearching: false,
        countGuestQuery: 0,
    },
    mutations: {
        isSearching(state, searching) {
            state.searching = searching;
        },
        gotGuestStatistics(state, statistics) {
            state.guestStatistics = statistics;
        },
        gotGuestProfile(state, profile) {
            state.profiles[profile.id] = profile;
        },
        gotGuestValue(state, dto) {
            state.values[dto.id] = dto.result;
        },
        gotQueryResult(state, result) {
            console.log("GUESTS", result);
            state.queryResult = result;
        },
        clearQuery(state) {
            state.queryResult = [];
        },
        gotCountByGuestQueryResult(state, result) {
            state.countGuestQuery = result;
        },
        isGuestQuerySearching(state, result) {
            state.guestQuerySearching = result;
        }
    },
    actions: {
        async getStatistics({ commit, state }, force = true) {
            if (!force && state.guestStatistics !== null) return;
            const result = await getGuestStatistics.get();
            if (result) commit("gotGuestStatistics", result);
        },
        async clearQuery({ commit }) {
            commit("clearQuery");
        },
        async queryGuests({ commit }, query) {
            commit('isSearching', true)
            const result = await queryGuests.get(query);
            commit('isSearching', false)
            if (result) commit("gotQueryResult", result);
        },
        async getGuest({ commit, state }, id, force = true) {
            if (!force && !(id in state.profiles)) return;
            const result = await getGuestProfile.get(id);
            if (result) commit("gotGuestProfile", result);
        },
        async getGuestValue({ commit, state }, id, force = true) {
            if (!force && !(id in state.values)) return;
            const result = await getGuestValue.get(id);
            if (result) commit("gotGuestValue", { id: id, result: result });
        },
        async create({ dispatch }, dto) {
            const result = await addGuestProfile.post(dto);
            return result;
        },
        async update({ dispatch }, dto) {
            await updateGuestProfile.put(dto);
            await dispatch("getGuest", dto.id)
        },
        async delete({ dispatch }, id) {
            await deleteGuestProfile.del(id);
        },
        async addVenueConsent({ dispatch }, dto) {
            await addVenueConsent.post(dto);
            await dispatch("getGuest", dto.guestId)
        },
        async removeVenueConsent({ dispatch }, { guestId, venueId, consent }) {
            await removeVenueConsent.del(guestId, venueId, consent);
            await dispatch("getGuest", guestId)
        },

        async addGuestNote({ dispatch }, dto) {
            await addGuestProfileNote.post(dto);
            await dispatch("getGuest", dto.guestId)
        },

        async getCountByGuestQuery({ commit }, query) {
            await commit("isGuestQuerySearching", true);
            const result = await getCountByGuestQuery.post(query);
            await commit("gotCountByGuestQueryResult", result);
            await commit("isGuestQuerySearching", false);
            return result;
        }

    },
    getters: {
        consentNames: state => state.consentNames,
        consentTypes: state => state.consentTypes,
        profile: state => (id) => id in state.profiles ? state.profiles[id] : null,
        value: state => (id) => id in state.values ? state.values[id] : null,
        queryResult: state => state.queryResult,
        guestStatistics: state => state.guestStatistics,
        isSearching: state => state.searching,
        countGuestQuery: state => state.countGuestQuery,
        guestQuerySearching: state => state.guestQuerySearching,
    }
};
